import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'player-skip-back', 'PlayerSkipBack', [["path",{"d":"M20 5v14l-12 -7l12 -7","key":"svg-0"}],["path",{"d":"M4 5l0 14","key":"svg-1"}]]);